export type ThemePref = 'light' | 'dark' | 'auto';

export function loadTheme(): ThemePref {
  try { const t = localStorage.getItem('ct_theme'); return t === 'light' || t === 'dark' ? t : 'auto'; } catch { return 'auto'; }
}

export function applyTheme(t: ThemePref): void {
  if (t === 'auto') delete document.documentElement.dataset.theme; else document.documentElement.dataset.theme = t;
  try { localStorage.setItem('ct_theme', t); } catch { /* chế độ riêng tư: bỏ qua */ }
}
